"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBoolean = void 0;
const getBoolean = value => {
  switch (typeof value) {
    case 'undefined':
      return true;
    case 'function':
      return value();
    default:
      return value;
  }
};
exports.getBoolean = getBoolean;